import React, { useState } from "react"
import { IconButton, TextField } from "@mui/material"
import { Add, Remove } from "@mui/icons-material"
import { latLngArrayToGeoJSON } from "../../../utils/geoJson"

export default function AddFarmAreaInput({ features, setFeatures }) {
  const [coordinates, setCoordinates] = useState([
    { lat: 0, lng: 0 },
    { lat: 0, lng: 0 },
    { lat: 0, lng: 0 },
    { lat: 0, lng: 0 },
  ])

  const handleChange = (unit, index) => (e) => {
    /// update the index element of array with the new value
    const newCoordinates = coordinates.map((coordinate, i) => {
      if (i === index) {
        return {
          ...coordinate,
          [unit]: e.target.value,
        }
      }
      return coordinate
    })
    setCoordinates(newCoordinates)
    setFeatures(latLngArrayToGeoJSON(newCoordinates))
  }

  const removeLocation = (index) => () => {
    const newCoordinates = coordinates.filter((_, i) => i !== index)
    setCoordinates(newCoordinates)
  }

  return (
    <>
      {coordinates.map((coordinate, index) => (
        <div key={index} style={{ margin: 10 }}>
          <TextField
            label="Latitude"
            variant="outlined"
            type="number"
            value={coordinate.lat}
            onChange={handleChange("lat", index)}
          />
          <TextField
            label="Longitude"
            type="number"
            variant="outlined"
            value={coordinate.lng}
            onChange={handleChange("lng", index)}
          />
          <IconButton onClick={removeLocation(index)}>
            <Remove />
          </IconButton>
        </div>
      ))}
      <IconButton
        onClick={() => setCoordinates([...coordinates, { lat: 0, lng: 0 }])}
      >
        <Add />
      </IconButton>
    </>
  )
}
